// EmployeeTerminationApproval.js

import React, { useEffect, useState, useRef } from 'react';
import './EmployeeTerminationApprovalHr.css';
import { getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import {
    getPendingTerminationsHR,
    approveTerminationHR
} from '../../../services/resignationService';
import { getClause } from '../../../services/ClauseService';
import { format } from 'date-fns';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import Select from 'react-select';
const EmployeeTerminationApprovalHr = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [action, setAction] = useState({});
    const [hrRemarks, setHrRemarks] = useState('');
    const [errors, setErrors] = useState({});
    const [rowLoading, setRowLoading] = useState({});
    //  Modal states
    const [showModal, setShowModal] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const textareaRef = useRef(null);
    const [isFocused, setIsFocused] = useState({ clause: false });
    const [clauses, setClauses] = useState([]);
    const effectRan = useRef(false);
    const [formData, setFormData] = useState({
        email: '',
        phone: '',
        //decision: '',
        cc: '',
        subject: '',
        clause: '',
        message: ''
    });
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await getPendingTerminationsHR();
            setData(res);



        } catch (e) {
            setErrors({ fetch: 'Failed to load data' });
        } finally {
            setLoading(false);
        }
    };

    const handleAction = (id, value) => {
        setAction(prev => ({ ...prev, [id]: value }));
        setErrors(prev => ({ ...prev, [id]: null }));
    };

    // const handleRemarks = (id, value) => {
    //     setHrRemarks(prev => ({ ...prev, [id]: value }));
    // };

    const validate = (id) => {
        if (!action[id]) {
            setErrors(prev => ({ ...prev, [id]: 'Select approve/reject' }));
            return false;
        }
        if (action[id] === 'reject') {
            setErrors(prev => ({ ...prev, [id]: 'Remarks required for reject' }));
            return false;
        }
        return true;
    };

    // Fetch Clauses
    useEffect(() => {
        const fetchClauses = async () => {
            try {
                //  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/genders`);
                const data = await getClause();
                //const data = response.data;
                if (Array.isArray(data)) {
                    setClauses(data.map(item => ({
                        value: item.clauseId,
                        label: item.clauseType,
                        content: item.content
                    })));
                } else {
                    console.error('Invalid response format: genders should be an array');
                }
            } catch (error) {
                console.error('Error fetching genders:', error);
            }
        };
        if (effectRan.current === false) {
            fetchClauses();
        }
        return () => {
            effectRan.current = true;
        }

    }, []);

    const handleSubmit = async (id) => {
        if (!validate(id)) return;

        const audit = getAuditLog();

        const payload = {
            approved: action[id] === 'approve',
            hrRemarks: hrRemarks.trim() || "",
            managerId: audit?.employeeId || '',
            auditlog: {
                name: audit?.name || '',
                role: audit?.role || '',
                employeeId: audit?.employeeId || ''
            }
        };

        setRowLoading(prev => ({ ...prev, [id]: true }));

        try {
            await approveTerminationHR(id, payload);
            setData(prev => prev.filter(d => d.id !== id));
        } catch (e) {
            setErrors(prev => ({
                ...prev,
                [id]: 'Failed to submit'
            }));
        } finally {
            setRowLoading(prev => ({ ...prev, [id]: false }));
        }
    };


    //  Open modal
    const handleEdit = (emp) => {
        setSelectedEmployee(emp);
        setFormData({
            email: emp.email || '',
            phone: emp.contact || '',
            //decision: '',
            cc: '',
            subject: '',
            clause: '',
            message: ''
        });
        setShowModal(true);
    };

    //  Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    //  Submit
    const handleSend = async () => {
        if (!formData.clause) {
            alert("Please select clause");
            return;
        }

        if (!formData.message) {
            alert("Message is required");
            return;
        }

        const audit = getAuditLog();

        const payload = {
            approved: true, // HR final action

            //  existing
            //hrRemarks: formData.message,
            managerId: audit?.employeeId || '',

            //  NEW (VERY IMPORTANT)
            clauseId: formData.clause,
            message: formData.message,
            subject: formData.subject || `Termination Notice - ${selectedEmployee.employeeName}`,
            cc: formData.cc,

            auditlog: {
                name: audit?.name || '',
                role: audit?.role || '',
                employeeId: audit?.employeeId || ''
            }
        };

        try {
            setRowLoading(prev => ({ ...prev, [selectedEmployee.id]: true }));

            await approveTerminationHR(selectedEmployee.id, payload);

            setData(prev => prev.filter(d => d.id !== selectedEmployee.id));

            setShowModal(false);

            alert("Employee terminated successfully"); //  optional UX

        } catch (e) {
            alert("Failed to submit");
        } finally {
            setRowLoading(prev => ({ ...prev, [selectedEmployee.id]: false }));
        }
    };
    if (loading) return <div className="hr-loader">Loading...</div>;

    const resizeTextarea = () => {
        const el = textareaRef.current;
        if (!el) return;

        el.style.height = "auto";

        const maxHeight = 20 * 24; // 20 lines

        if (el.scrollHeight > maxHeight) {
            el.style.height = maxHeight + "px";
            el.style.overflowY = "auto";
        } else {
            el.style.height = el.scrollHeight + "px";
            el.style.overflowY = "hidden";
        }
    };

    return (
        <div className="hr-container">
            <h2 className="hr-title">HR Termination Approval</h2>

            {errors.fetch && <div className="hr-error-banner">{errors.fetch}</div>}

            <div className="hr-table-wrapper">
                <table className="hr-table">
                    <thead>
                        <tr className="hr-header">
                            <th>S.No</th>
                            <th>District</th>
                            <th>Employee Name</th>
                            <th>Contact</th>
                            <th>Email</th>
                            <th>Designation</th>
                            <th>Requested By</th>
                            <th>Joining Date</th>
                            <th>Termination Date</th>
                            <th>APM Reason </th>
                            <th>Approved Date</th>
                            <th>Approved By</th>
                            <th>PM Reason </th>
                            {/* <th>HR Remarks</th> */}
                            <th>Action</th>
                            {/* <th>Submit</th> */}
                        </tr>
                    </thead>

                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan="16" className="hr-empty">
                                    No pending requests
                                </td>
                            </tr>
                        ) : (
                            data.map((t, i) => (
                                <tr key={t.id}>
                                    <td>{i + 1}</td>
                                    <td>{t.district}</td>
                                    <td>{t.employeeName}</td>
                                    <td>{t.contact}</td>
                                    <td>{t.email}</td>
                                    <td>{t.designation}</td>
                                    {/* <td>{format(t.requestDate, 'dd-MM-yyyy')}</td> */}
                                    <td>{capitalizeFirstLetter(t.requestedBy)}</td>
                                    <td className=' text-nowrap'>{format(t.joiningDate, 'dd-MM-yyyy')}</td>
                                    <td>{format(t.requestedTerminationDate, 'dd-MM-yyyy')}</td>

                                    {/* Reason 1 */}
                                    <td className="hr-reason">{t.reason}</td>

                                    {/* Approved Date */}
                                    <td className=' text-nowrap'>{format(t.approvedDate, 'dd-MM-yyyy') || '-'}</td>

                                    {/* Approved By */}
                                    <td>{t.approvedByName || '-'}</td>

                                    {/* Reason 2 (Manager Remarks) */}
                                    <td className="hr-reason">
                                        {t.pmRemarks || '-'}
                                    </td>

                                    {/* HR Remarks */}
                                    {/* <td>
                                    
                                        <input
                                            className="hr-textarea"
                                            placeholder="Enter HR remarks"
                                            value={hrRemarks}
                                            title={hrRemarks}
                                            onChange={(e) => setHrRemarks(e.target.value)}
                                        />
                                    </td> */}

                                    {/* Action */}
                                    {/* <td className="">
                                        <div>
                                            <label>
                                                <input
                                                    type="radio"
                                                    checked={action[t.id] === 'approve'}
                                                    onChange={() =>
                                                        handleAction(t.id, 'approve')
                                                    }
                                                />
                                                Approve
                                            </label>

                                            <label>
                                                <input
                                                    type="radio"
                                                    checked={action[t.id] === 'reject'}
                                                    onChange={() =>
                                                        handleAction(t.id, 'reject')
                                                    }
                                                />
                                                Reject
                                            </label>
                                        </div>
                                    </td> */}

                                    {/* Submit */}
                                    {/* <td>
                                        <button
                                            className="hr-btn"
                                            onClick={() => handleSubmit(t.id)}
                                            disabled={rowLoading[t.id]}
                                        >
                                            {rowLoading[t.id] ? 'Saving...' : 'Submit'}
                                        </button>

                                        {errors[t.id] && (
                                            <div className="hr-error">
                                                {errors[t.id]}
                                            </div>
                                        )}
                                    </td> */}
                                    <td>
                                        <button
                                            className="hr-btn"
                                            onClick={() => handleEdit(t)}
                                            disabled={rowLoading[t.id]}
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {/*  Modal */}
            {showModal && (
                <div className="hr-modal-overlay">
                    <div className="hr-modal-box">
                        <h2 className="hr-modal-heading">Termination Action</h2>

                        <div className="hr-modal-maincontainer">
                            <div className="hr-modal-container-part">
                                <div className="hr-modal-floating-label-container-1">

                                    <input
                                        type="text"
                                        name="employeeName"
                                        value={selectedEmployee.employeeName}
                                        disabled
                                        placeholder=" "
                                    />
                                    <label>Employee Name</label>
                                </div>
                            </div>
                            <div className="hr-modal-container-part">
                                <div className="hr-modal-floating-label-container-2">

                                    <input
                                        type="text"
                                        name="designation"
                                        value={selectedEmployee.designation}
                                        disabled
                                        placeholder=" "
                                    />
                                    <label>Designation</label>
                                </div>
                            </div>
                        </div>

                        <div className="hr-modal-maincontainer">
                            <div className="hr-modal-container-part">
                                <div className="hr-modal-floating-label-container-2">

                                    <input
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        disabled
                                        placeholder=" "
                                    />
                                    <label>Phone</label>
                                </div>
                            </div>
                            <div className="hr-modal-container-part">
                                <div className="hr-modal-floating-label-container-2">

                                    <input
                                        type="text"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder=" "
                                        disabled
                                    />
                                    <label>Sent to Email</label>
                                </div>
                            </div>
                        </div>

                        <div className="hr-modal-maincontainer">

                            <div className="hr-modal-container-part">
                                <div className="hr-modal-floating-label-container-2">
                                    <input
                                        type="text"
                                        name="cc"
                                        value={formData.cc}
                                        onChange={handleChange}
                                        placeholder=" "
                                    />
                                    <label>CC To</label>
                                </div>
                            </div>
                            <div className="hr-modal-container-part">
                                <div className="hr-modal-floating-label-container-2">

                                    <input
                                        type="text"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        placeholder=" "
                                    />
                                    <label>Subject</label>
                                </div>
                            </div>
                        </div>


                        <div className="hr-modal-maincontainer">
                            <div className="hr-modal-container-part">
                                <div className={`hr-modal-floating-label-container-2 ${isFocused.clause || !!formData.clause ? 'float-label' : ''}`}>

                                    <Select
                                        name="clause"
                                        options={clauses}
                                        value={clauses.find(c => c.value === formData.clause) || null}

                                        onChange={(option) => {
                                            setFormData(prev => ({
                                                ...prev,
                                                clause: option.value,
                                                message: option.content
                                            }));

                                            setIsFocused(prev => ({ ...prev, clause: true }));

                                            //  resize after content update
                                            setTimeout(resizeTextarea, 0);
                                        }}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, clause: false }))}
                                        placeholder=""

                                        styles={selectStyles}
                                    />
                                    <label>Clause</label>
                                </div>
                            </div>
                        </div>

                        <div className="hr-modal-maincontainer">
                            <div className="hr-modal-container-part">
                                <div className={`hr-modal-floating-label-container-1 
                                     ${formData.message ? 'float-label' : ''}`}>

                                    <textarea
                                        ref={textareaRef}
                                        name="message"
                                        value={formData.message}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, message: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, message: false }))}
                                        onChange={(e) => {
                                            handleChange(e);
                                            resizeTextarea(); // ✅ clean call
                                        }}
                                        style={{
                                            resize: "none",
                                            lineHeight: "24px"
                                        }}
                                        placeholder=" "
                                    />
                                    <label>Message</label>
                                </div>
                            </div>
                        </div>
                        <div className="hr-modal-actions">
                            <button onClick={handleSend} disabled={!formData.clause || !formData.message || !formData.subject || !formData.cc} className='send-btn'>
                                {rowLoading[selectedEmployee?.id] ? 'Sending...' : 'Send'}
                            </button>
                            <button className='btn-cancel-res' onClick={() => setShowModal(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EmployeeTerminationApprovalHr;